import { connect } from 'react-redux'
import { compose } from 'recompose'

import Component from './component'
import withPermissions from '../../globals/components/withPermissions'

export default compose(withPermissions, connect())(Component)
